

function drawLine(ctx, startX, startY, endX, endY,color){
    ctx.save();
    ctx.strokeStyle = color;
    ctx.beginPath();
    ctx.moveTo(startX,startY);
    ctx.lineTo(endX,endY);
    ctx.stroke();
    ctx.restore();
}


class LineChart {
  constructor(options) {
    this.options = options;
    this.canvas = options.canvas;
    this.ctx = this.canvas.getContext("2d");
    this.colors = options.colors;
    this.titleOptions = options.titleOptions;
    this.maxValue = options.maxValue ;
    this.xScale = options.xScale ;
    this.ctx.reset();
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.beginPath();
  }

  drawLabel() {
    this.ctx.save();
    this.ctx.textBaseline = "bottom";
    this.ctx.textAlign = this.titleOptions.align;
    this.ctx.font = `italic 12pt ${this.titleOptions.font.family}`;
    let xPos = 80 ;
    this.ctx.fillStyle = "red" ;
    this.ctx.fillText("Red: Incoming", xPos, this.canvas.height - 5);
    this.ctx.fillStyle = "green" ;
    xPos = 220;
    this.ctx.fillText("Green: Outgoing", xPos, this.canvas.height - 5);
  }

  // Xslot 0 - 19  
  drawLines(Xslot, PercentfromY, PercenttoY, color) {
    var canvasActualHeight = this.canvas.height - this.options.padding * 2;

    let inc = (this.canvas.width - this.options.padding) / this.xScale ;
    let fromX = this.options.padding + inc * Xslot ;
    let toX = fromX + inc ;
    
    var fromY = canvasActualHeight * (1 - PercentfromY / this.maxValue) + this.options.padding;
    var toY   = canvasActualHeight * (1 - PercenttoY / this.maxValue) + this.options.padding;

    drawLine( this.ctx, fromX, fromY, toX, toY, color );
  }
  
  drawGridLines() {
    var canvasActualHeight = this.canvas.height - this.options.padding * 2;

    var gridValue = 0;

    while (gridValue <= this.maxValue) {
      var gridY =
        canvasActualHeight * (1 - gridValue / this.maxValue) +
        this.options.padding;
      drawLine(
        this.ctx,
        0,
        gridY,
        this.canvas.width,
        gridY,
        this.options.gridColor
      );
      drawLine(
        this.ctx,
        30,
        this.options.padding/2,
        30,
        gridY + this.options.padding/2,
        this.options.gridColor
      );
      // Writing grid markers 
      this.ctx.save();
      this.ctx.fillStyle = "black" ;
      this.ctx.textBaseline = "bottom";
      this.ctx.font = "bold 10px Arial";

      let unit = Math.round(gridValue) ;
      let x = gridValue ;
      unit = x + this.options.unit ;
      this.ctx.fillText(unit, 0, gridY - 2);
      this.ctx.restore();
      gridValue +=  this.maxValue / this.options.gridScale ;
    }
  }

  drawLegend(legend) {
    let pIndex = 0;
    let ul = document.createElement("ul");
    legend.append(ul);
    for (let ctg of Object.keys(this.options.data)) {
      let li = document.createElement("li");
      li.style.listStyle = "none";
      li.style.borderLeft =
        "20px solid " + this.colors[pIndex % this.colors.length];
      li.style.padding = "5px";
      li.textContent = ctg;
      ul.append(li);
      pIndex++;
    }
  }

  draw() {
    this.drawGridLines();
    this.drawLabel();
  }
}

export default LineChart ;
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
